

import Vue from "vue";
import Component from "vue-class-component";
import TotaisMesesModel from "@/models/grafico/totais-meses.model";
import TotaisContratosModel from "@/models/grafico/totais-contratos.model";
import GraficosService from "@/service/graficos.service"
import TotaisClientesModel from "@/models/grafico/totais-clientes.model";
import TotaisEsferasModel from "@/models/grafico/totais-esferas.model";
import TotaisEmpresasModel from "@/models/grafico/totais-empresas.model";
import TotaisGeraisModel from "@/models/grafico/totais-gerais.model";
import TotaisReguaModel from "@/models/grafico/totais-regua.model";

@Component({
  name: "Inicio",
})
export default class Inicio extends Vue {

  step = 0;

  totaisGerais = new TotaisGeraisModel();
  loadingGerais = true;

  totaisMeses: Array<any> = [];
  loadingMeses = true;

  totaisContratos: Array<any> = [];
  loadingContratos = true;

  totaisClientes: Array<any> = [];
  loadingClientes = true;

  totaisEsferas: Array<any> = [];
  loadingEsferas = true;

  totaisEmpresas: Array<any> = [];
  loadingEmpresas = true;

  totaisRegua: Array<any> = [];
  loadingRegua = true;

  formatMoney(money: any) {
    if (money) {
      return money.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'});
    } else {
      return Number.parseInt("0").toLocaleString('pt-br', {style: 'currency', currency: 'BRL'});
    }
  }

  carregarTotaisGerais() {
    GraficosService.getTotaisGerais().then((response) => {
      this.totaisGerais = response.data;
      this.loadingGerais = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisMeses() {
    GraficosService.getTotaisMeses().then((response) => {
      response.data.forEach((item: TotaisMesesModel) => {
        this.totaisMeses.push([item.mes_nome?.substring(0, 3).toUpperCase(), item.total]);
      });
      this.loadingMeses = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisContratos() {
    GraficosService.getTotaisContratos().then((response) => {
      response.data.forEach((item: TotaisContratosModel) => {
        this.totaisContratos.push([item.Contrato, item.TOTAL_VENDIDO]);
      });
      this.loadingContratos = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisClientes() {
    GraficosService.getTotaisClientes().then((response) => {
      response.data.forEach((item: TotaisClientesModel) => {
        this.totaisClientes.push([item.Nome_Fornecedor, item.TOTAL_VENDIDO]);
      });
      this.loadingClientes = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisEsferas() {
    GraficosService.getTotaisEsferas().then((response) => {
      response.data.forEach((item: TotaisEsferasModel) => {
        this.totaisEsferas.push([item.Esfera, item.TOTAL_VENDIDO]);
      });
      this.loadingEsferas = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisEmpresas() {
    GraficosService.getTotaisEmpresas().then((response) => {
      response.data.forEach((item: TotaisEmpresasModel) => {
        this.totaisEmpresas.push([item.Empresa_Nome, item.TOTAL_VENDIDO]);
      });
      this.loadingEmpresas = false;
    }).catch((error) => {
      console.error(error);
    });
  }

  carregarTotaisRegua() {
    GraficosService.getTotaisRegua().then((response) => {
      response.data.forEach((item: TotaisReguaModel) => {
        this.totaisRegua.push([item.descricao, item.total]);
      });
      this.loadingRegua = false;
    }).catch((error) => {
      console.error(error);
    });
  }


  mounted() {
    this.carregarTotaisGerais();
    this.carregarTotaisMeses();
    this.carregarTotaisContratos();
    this.carregarTotaisClientes();
    this.carregarTotaisEsferas();
    this.carregarTotaisEmpresas();
    this.carregarTotaisRegua();
  }
}
